import React, { useState, useEffect, useCallback, useRef } from 'react';
import ConfirmReload from '../components/ConfirmReload';
import DateRangePicker from '@/components/ui/DateRangePicker';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { format } from 'date-fns';
import { NavLink } from 'react-router-dom';
import PubSub from 'pubsub-js';
import { Search, SlidersHorizontal, ChevronDown, Loader2 } from 'lucide-react';
import { cn, safeParseDate } from '@/lib/utils';
import { computeMenuAlignFromTrigger, absoluteMenuAlignClasses } from '../_helpers/dropdownViewportAlign';

function TopMenu({ dashboardListRendered, handleChange, handleChangeDateNew, handeChangefilter, dashboardTitle, startDate: propStartDate, endDate: propEndDate, handleChangeAllDirectOverride }) {
    // Get initial dates
    const getInitialDates = () => {
        const defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 30);
        const defaultEndDate = new Date();
        
        const storedStartDate = localStorage.getItem('User_Start_Date');
        const storedEndDate = localStorage.getItem('User_End_Date');
        
        const startdate = (storedStartDate && storedStartDate !== "" && storedStartDate !== "null")
            ? safeParseDate(storedStartDate, defaultStartDate) : defaultStartDate;
        const enddate = (storedEndDate && storedEndDate !== "" && storedEndDate !== "null")
            ? safeParseDate(storedEndDate, defaultEndDate) : defaultEndDate;
        
        return { startdate, enddate };
    };

    // Get user role info
    const getUserRoleInfo = () => {
        let roletype = '', rolename = '';
        try {
            const userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userrole === "Distributor" && userdata.wholesaler === "Avenel") {
                roletype = "avdistributor";
                rolename = userdata.email;
            } else if (userdata.userrole === "Distributor" && userdata.wholesaler !== "Avenel") {
                roletype = "distributor";
                rolename = userdata.paramsname;
            } else {
                roletype = userdata.userrole;
                rolename = userdata.paramsname;
            }
        } catch (e) {}
        return { roletype, rolename };
    };

    const { startdate, enddate } = getInitialDates();
    const { roletype, rolename } = getUserRoleInfo();
    const userdata = JSON.parse(localStorage.getItem('user') || '{}');

    // State
    const [state, setState] = useState({
        dashboardName: userdata?.dList?.[0]?.dashboardName || '',
        dashboardList: [],
        ConfirmReloadPopUp: false,
        radioButtonSelection: false,
        radioButtonValue: 'totalpaid',
        searchTextSelection: false,
        searchTextType: '',
        searchTextValue: '',
        AdFilterPopup: false,
        WhFilterPopup: false,
        CreateNewFilter: false,
        DisFilterPopup: false,
        ConfirmationMessageTitle: '',
        userdata: userdata,
        dist_usertype: 'Direct',
        UserFilter: [],
        UserFilterList: [],
        SearchDispay: [],
        loading: false,
        startDate: format(startdate, "MM/dd/yyyy"),
        endDate: format(enddate, "MM/dd/yyyy"),
        roletype: roletype,
        rolename: rolename,
        ClaimType: [
            { id: "totalpaid1", value: "totalpaid", isChecked: true, pname: "Total" },
            { id: "reversed3", value: "reversed", isChecked: false, pname: "Reversed" },
            { id: "netpaid2", value: "netpaid", isChecked: false, pname: "Net" },
            { id: "compensable4", value: "compensable", isChecked: false, pname: "Paid" }
        ]
    });

    // Refs
    const typingTimeoutRef = useRef(null);
    const currentControllerRef = useRef(null);
    const pubsubTokenRef = useRef(null);
    const searchInputRef = useRef(null);
    const filterDropdownRef = useRef(null);
    const filterButtonRef = useRef(null);

    // UI state for dropdown/autocomplete (replacing imperative DOM manipulation)
    const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
    const [filterMenuAlign, setFilterMenuAlign] = useState('start');
    const wholesalerOverrideTriggerRef = useRef(null);
    const [wholesalerOverrideAlign, setWholesalerOverrideAlign] = useState('start');
    const distributorBrokerOverrideTriggerRef = useRef(null);
    const [distributorBrokerOverrideAlign, setDistributorBrokerOverrideAlign] = useState('start');
    const [autocompleteVisible, setAutocompleteVisible] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    // Handle API response
    const handleResponse = useCallback((response) => {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            } catch (e) {
                return [];
            }
        });
    }, []);

    // Handle date change
    const handleChangeDate = useCallback((e) => {
        handleChangeDateNew(e);
    }, [handleChangeDateNew]);

    // Handle calendar apply
    const handleCalendar = useCallback((e, picker) => {
        const changedStartDate = format(picker.startDate, "MM/dd/yyyy");
        const changedEndDate = format(picker.endDate, "MM/dd/yyyy");
        localStorage.setItem('User_Start_Date', changedStartDate);
        localStorage.setItem('User_End_Date', changedEndDate);
        handleChangeDate(changedStartDate + '-' + changedEndDate);
        setState(prev => ({ ...prev, startDate: changedStartDate, endDate: changedEndDate }));
    }, [handleChangeDate]);

    // Create advance filter JSON
    const createAdvanceFilterJson = useCallback((nodetype, nodevalue, Confirm_Type) => {
        let Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter'));
        
        let arr = [];
        if (Created_Advance_Filter != null && Created_Advance_Filter !== '' && Created_Advance_Filter !== undefined && Created_Advance_Filter !== "null" && typeof Created_Advance_Filter === 'object' && Object.keys(Created_Advance_Filter).length > 0) {
            if (Confirm_Type === 'RadioSelect') {
                if (Created_Advance_Filter.hasOwnProperty('PBM')) {
                    Created_Advance_Filter["PBM"].splice(0, Created_Advance_Filter["PBM"].length);
                }
            }
            let IsMatched = false;
            Object.keys(Created_Advance_Filter).forEach(key => arr.push({ Name: key, Value: Created_Advance_Filter[key] }));
            for (let ij = 0; ij < arr.length; ij++) {
                if (arr[ij].Name === nodetype) {
                    IsMatched = true;
                    let checkavail = 0;
                    Created_Advance_Filter[nodetype].forEach((e1) => {
                        if (e1.toLowerCase() === nodevalue.toLowerCase()) { checkavail++; }
                    });
                    if (checkavail === 0) {
                        Created_Advance_Filter[nodetype].push(nodevalue);
                        localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
                        localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                        localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                    }
                    break;
                }
            }
            if (!IsMatched) {
                try {
                    let JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                    let TempJson = JSON.stringify(Created_Advance_Filter).replace('{', '').replace('}', '');
                    TempJson = '{' + TempJson + ',' + JsonData + '}';
                    localStorage.setItem('Advance_Filter', TempJson);
                    localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                    localStorage.setItem('Updated_AdFilter_Status', TempJson);
                } catch (e) {

                }
            }
        } else {
            try {
                let JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                localStorage.setItem('Advance_Filter', JSON.stringify(JSON.parse(JsonData)["dataset"]));
                localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
            } catch (e) {

            }
        }
    }, []);

    // Handle filter change - must be defined after createAdvanceFilterJson
    const handlechangea = useCallback((e) => {
        // If e has heading and value properties, it's from a chart click
        if (e && e.heading && e.value) {
            createAdvanceFilterJson(e.heading, e.value, 'Search');
            localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
            localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
            localStorage.setItem('Updated_Filter_Status', 'true');
        }
        
        // Always call handeChangefilter to trigger refresh
        handeChangefilter(e);
    }, [handeChangefilter, createAdvanceFilterJson]);

    // Handle RXS radio button
    const HandleRXSRadioButton = useCallback((e) => {
        const NewHDType = e.target.value;
        
        setState(prev => ({
            ...prev,
            ClaimType: prev.ClaimType.map(c => ({ ...c, isChecked: c.value === e.target.value }))
        }));
        
        try {
            const LocalHDType = localStorage.getItem('Updated_HD_Type');
            localStorage.setItem('Prev_HD_Type', LocalHDType);
            localStorage.setItem('Updated_HD_Type', NewHDType);
            localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
            
            // Check if PBM: HD filter needs to be added for non-totalpaid claim types
            // Note: HD filter persists until Reset button is clicked (handled in FilterTag.js)
            if (NewHDType !== 'totalpaid') {
                try {
                    let advanceFilter = JSON.parse(localStorage.getItem('Advance_Filter'));
                    
                    // If no filter or PBM filter doesn't exist or HD is not in PBM array
                    if (!advanceFilter || !advanceFilter.PBM || !advanceFilter.PBM.includes('HD')) {
                        // Add PBM: HD filter
                        if (!advanceFilter) {
                            advanceFilter = {};
                        }
                        if (!advanceFilter.PBM) {
                            advanceFilter.PBM = [];
                        }
                        if (!advanceFilter.PBM.includes('HD')) {
                            advanceFilter.PBM.push('HD');
                        }
                        
                        localStorage.setItem('Advance_Filter', JSON.stringify(advanceFilter));
                        localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(advanceFilter));
                    }
                } catch (filterError) {
                    // If error parsing filter, set default PBM: HD
                    localStorage.setItem('Advance_Filter', '{"PBM":["HD"]}');
                    localStorage.setItem('Updated_AdFilter_Status', '{"PBM":["HD"]}');
                }
            }
            // When switching to Total (totalpaid), do NOT remove HD filter
            // HD filter will persist until Reset button is clicked (handled in FilterTag.js handleResetButton)
            
            handlechangea();
        } catch (e) {}
    }, [handlechangea]);

    // Confirm reload popup
    const ConfirmReloadPopUp = useCallback((e) => {
        setState(prev => ({ ...prev, ConfirmReloadPopUp: !prev.ConfirmReloadPopUp }));
    }, []);

    // Toggle filter popups
    const toggleWhFilterPopup = useCallback(() => {
        const wname = state.userdata.wholesaler;
        setState(prev => ({ ...prev, WhFilterPopup: !prev.WhFilterPopup, dashboardName: wname }));
        document.body.classList.toggle('no-scroll');
    }, [state.userdata.wholesaler]);

    const toggleAdFilterPopup = useCallback(() => {
        setState(prev => ({ ...prev, AdFilterPopup: !prev.AdFilterPopup }));
        document.body.classList.toggle('no-scroll');
    }, []);

    const toggleDisFilterPopup = useCallback(() => {
        setState(prev => ({ ...prev, DisFilterPopup: !prev.DisFilterPopup }));
        document.body.classList.toggle('no-scroll');
    }, []);

    // Filter dropdown toggle
    const filterDropdown = useCallback((event) => {
        event.stopPropagation();
        setFilterDropdownOpen((prev) => {
            const next = !prev;
            if (next) setFilterMenuAlign(computeMenuAlignFromTrigger(filterButtonRef.current));
            return next;
        });
    }, []);

    // Handle broker filter
    const handleBrokerFilter = useCallback((filterType) => {
        setState(prev => ({ ...prev, userdata: JSON.parse(localStorage.getItem('user')), dist_usertype: filterType }));
        handleChangeAllDirectOverride(filterType);
        localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
    }, [handleChangeAllDirectOverride]);

    // Get user filter set
    const GetUserFilterSet = useCallback((FilterName, FilterJson, DashboardId) => {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ FilterName, FilterJson, DashboardId })
            };
            return fetch(`/api/Filter/GetUserAdFilter`, requestOptions)
                .then(handleResponse)
                .then(apidata => {
                    try { setState(prev => ({ ...prev, UserFilterList: apidata[0]["filterset"] })); } catch (e) {}
                });
        } catch (e) {}
    }, [handleResponse]);

    // Get filter data
    const GetFilterData = useCallback((API_URL, uname) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uname })
        };
        return fetch(API_URL, requestOptions)
            .then(handleResponse)
            .then(apidata => {
                try {
                    setState(prev => ({ ...prev, UserFilter: apidata }));
                    localStorage.setItem('Prev_Filter_Status', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);
                    localStorage.setItem('Updated_Filter_Status', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);
                } catch (e) {}
            });
    }, [handleResponse]);

    // Search handlers
    const HandleSearchFocus = useCallback((e) => {
        if (e.target.value.length === 0) {
            setState(prev => ({ ...prev, SearchDispay: null }));
        }
    }, []);

    const GetSearchDataList = useCallback((text, roleType, roleName, whname) => {
        setAutocompleteVisible(true);
        if (currentControllerRef.current) currentControllerRef.current.abort();
        currentControllerRef.current = new AbortController();
        setState(prev => ({ ...prev, loading: true }));
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text, roletype: roleType, rolename: roleName, whname }),
            signal: currentControllerRef.current.signal
        };
        return fetch(`/api/Filter/SearchOnTypeText`, requestOptions)
            .then(handleResponse)
            .then(apidata => {
                if (Array.isArray(apidata) && apidata.length > 0) {
                    setState(prev => ({ ...prev, SearchDispay: apidata, loading: false }));
                } else {
                    setState(prev => ({ ...prev, SearchDispay: [], loading: false }));
                }
            }).catch(error => {
                if (error.name !== "AbortError") {
                    setState(prev => ({ ...prev, SearchDispay: [], loading: false }));
                }
            });
    }, [handleResponse]);

    const HandleSearchKeyUp = useCallback((e) => {
        const value = e.target.value;
        if (value.length < 2) {
            setState(prev => ({ ...prev, SearchDispay: null }));
            setAutocompleteVisible(false);
            return;
        }
        clearTimeout(typingTimeoutRef.current);
        typingTimeoutRef.current = setTimeout(() => {
            GetSearchDataList(value, state.roletype, state.rolename, state.userdata.wholesaler_Id?.toString());
        }, 300);
    }, [GetSearchDataList, state.roletype, state.rolename, state.userdata.wholesaler_Id]);

    const HandleSearchItemClick = useCallback((e) => {
        setSearchValue('');
        setAutocompleteVisible(false);
        setState(prev => ({ ...prev, SearchDispay: [] }));
        
        let nodevalue = e.currentTarget.getAttribute('data-nodevalue');
        let nodetype = e.currentTarget.getAttribute('data-nodetype');
        if (nodetype?.toLowerCase() === "prescribename") nodetype = "Prescriber";
        
        try {
            if (nodetype === "PBM" && (nodevalue === "CRX" || nodevalue === "HDX" || nodevalue === "HRX")) {
                const checkedType = state.ClaimType.find(c => c.isChecked);
                if (checkedType && checkedType.value !== "totalpaid") {
                    setState(prev => ({
                        ...prev,
                        searchTextSelection: true,
                        searchTextType: nodetype,
                        searchTextValue: nodevalue,
                        ConfirmationMessageTitle: 'This Selection will work only for Total Paid'
                    }));
                    return;
                }
            }
        } catch (e) {}

        // Add filter only; do not change HD type (e.g. keep 'compensable') - matches class component
        createAdvanceFilterJson(nodetype, nodevalue, 'Search');
        localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
        handlechangea();
    }, [createAdvanceFilterJson, handlechangea, state.ClaimType]);

    // Handle ad filter click
    const handleAdFilterClick = useCallback((e) => {
        try {
            const filterId = parseInt(e.target.getAttribute('data-filterid'));
            
            // Find the selected filter from the already-loaded list (matching production-v3)
            const selectedFilter = state.UserFilterList.filter((item) => item.dashboardId == filterId);
            
            if (selectedFilter && selectedFilter.length > 0) {
                // Parse the filter JSON and extract the dataset property (matching production-v3)
                const parsedFilter = JSON.parse(selectedFilter[0]["filterJson"]);
                const rawDataset = parsedFilter["dataset"];
                const datasetFilter = (rawDataset && typeof rawDataset === 'object' && Object.keys(rawDataset).length > 0)
                    ? JSON.stringify(rawDataset)
                    : null;
                
                // Close the filter dropdown
                setFilterDropdownOpen(false);
                
                // Save to localStorage (matching production-v3)
                localStorage.setItem('Updated_AdFilter_Status', datasetFilter);
                localStorage.setItem('Advance_Filter', datasetFilter);
                localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                
                // Trigger the filter change to reload data
                if (handeChangefilter) {
                    handeChangefilter();
                }
            }
        } catch (error) {

        }
    }, [state.UserFilterList, handeChangefilter]);

    // Dates are controlled via state.startDate/state.endDate - no DOM manipulation needed

    // PubSub subscriber
    const subscriber = useCallback((msg, data) => {
        try {
            // Update state to switch to Total tab when PBM: HD filter is removed
            setState(prev => ({
                ...prev,
                ClaimType: prev.ClaimType.map(c => ({ ...c, isChecked: c.value === 'totalpaid' }))
            }));
        } catch (e) {}
    }, []);

    // Initialize on mount
    useEffect(() => {
        pubsubTokenRef.current = PubSub.subscribe('PBM', subscriber);

        // Click outside handler - close filter dropdown and autocomplete
        const clickHandler = (event) => {
            // Close filter dropdown if click is outside
            if (filterButtonRef.current && !filterButtonRef.current.contains(event.target) &&
                filterDropdownRef.current && !filterDropdownRef.current.contains(event.target)) {
                setFilterDropdownOpen(false);
            }
            // Close autocomplete if click is outside search area
            if (searchInputRef.current && !searchInputRef.current.closest('.relative')?.contains(event.target)) {
                setAutocompleteVisible(false);
            }
        };
        document.addEventListener('click', clickHandler);

        // Initialize user data
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            setState(prev => ({ ...prev, dashboardList: user.dList }));
            dashboardListRendered(user.dList?.[0]?.dashboardName || '');
        }

        // Get filter data based on role
        if (state.userdata.userrole === "Admin") {
            GetFilterData('/api/admin/Admin_filter', "admin");
        } else if (state.userdata.userrole === "SubAdmin") {
            localStorage.setItem('Updated_Filter_Status', 'groupnumber_all_0');
        } else if (state.userdata.userrole === "Wholesaler") {
            GetFilterData('/api/ws/wholesaler_filter', escape(state.dashboardName?.replace(" Dashboard (wholesaler)", "").trim()));
        } else if (state.userdata.userrole === "Distributor") {
            if (state.userdata.wholesaler === "Avenel") {
                GetFilterData('/api/ds/distributor_filter', escape(state.userdata.email?.trim()));
            } else {
                GetFilterData('/api/ds/distributor_filter', escape(state.dashboardName?.replace(" Dashboard", "").trim()));
            }
        }
        GetUserFilterSet('', '', state.userdata?.dList?.[0]?.dashboardId);

        // Initialize HD Type
        if (state.userdata.userrole === "Admin") {
            try {
                const saved_type = localStorage.getItem('Updated_HD_Type');
                const checkforfilter = localStorage.getItem('Advance_Filter');
                if (saved_type && saved_type !== 'null') {
                    setState(prev => ({
                        ...prev,
                        ClaimType: prev.ClaimType.map(c => ({ ...c, isChecked: c.value === saved_type }))
                    }));
                } else {
                    setState(prev => ({
                        ...prev,
                        ClaimType: prev.ClaimType.map(c => ({ ...c, isChecked: c.value === 'compensable' }))
                    }));
                }
                if (checkforfilter && checkforfilter !== 'null') {
                    // Filter already exists — preserve the saved claim type
                    window.localStorage.setItem('Updated_HD_Type', saved_type || 'totalpaid');
                } else if (saved_type === 'totalpaid') {
                    // User explicitly removed PBM:HD (FilterTag sets type to 'totalpaid' on removal)
                    // Do NOT re-add the filter — respect the user's action
                } else if (!saved_type || saved_type === 'null') {
                    // Truly fresh session — no saved type yet, apply default
                    window.localStorage.setItem('Advance_Filter', '{"PBM":["HD"]}');
                    window.localStorage.setItem('Updated_HD_Type', 'compensable');
                } else {
                    // Non-totalpaid claim type is active but filter is missing — restore it
                    window.localStorage.setItem('Advance_Filter', '{"PBM":["HD"]}');
                    window.localStorage.setItem('Updated_HD_Type', saved_type);
                }
            } catch (e) {}
        } else {
            setState(prev => ({
                ...prev,
                ClaimType: prev.ClaimType.map(c => ({ ...c, isChecked: c.value === 'totalpaid' }))
            }));
            window.localStorage.setItem('Updated_HD_Type', 'totalpaid');
        }

        return () => {
            PubSub.unsubscribe(pubsubTokenRef.current);
            document.removeEventListener('click', clickHandler);
        };
    }, []);

    // Dates are rendered from state -- no DOM update needed on re-render

    return (
        <div id="dashboard_header" className="mb-4">
            {/* Single Consolidated Card for All Controls */}
            <div id="dashboard_header_inner" className="bg-card rounded-xl border shadow-sm p-4">
                <div className="flex flex-wrap items-end gap-4">
                    <DateRangePicker 
                        className="w-[320px] max-w-full flex-shrink-0 h-10"
                        initialSettings={{
                            startDate: state.startDate,
                            endDate: state.endDate,
                            maxDate: new Date(),
                            locale: { format: 'MM/DD/YYYY' }
                        }}
                        onApply={handleCalendar}
                    >
                        <div className="flex items-center gap-0 w-[320px] max-w-full rounded-md overflow-hidden border border-input bg-card hover:shadow-sm transition-shadow h-10">
                            <div className="flex items-center gap-1 px-3 flex-1">
                                <span className="text-sm text-muted-foreground whitespace-nowrap">From</span>
                                <Input
                                    type="text"
                                    className="bg-transparent text-sm cursor-pointer w-full !border-0 outline-none h-auto p-0 rounded-none"
                                    value={state.startDate}
                                    readOnly
                                />
                            </div>
                            <div className="h-6 w-px bg-border flex-shrink-0" />
                            <div className="flex items-center gap-1 px-3 flex-1">
                                <span className="text-sm text-muted-foreground whitespace-nowrap">To</span>
                                <Input
                                    type="text"
                                    className="bg-transparent text-sm cursor-pointer w-full !border-0 outline-none h-auto p-0 rounded-none"
                                    value={state.endDate}
                                    readOnly
                                />
                            </div>
                        </div>
                    </DateRangePicker>

                    {/* Search Input - grows to fill space */}
                    <div className="relative flex-1 min-w-[200px]">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                        <form autoComplete="off" onSubmit={e => e.preventDefault()}>
                            <Input ref={searchInputRef} id="myInput" type="text" name="myCountry" placeholder="Search" className="searchFilter pl-10" value={searchValue} onChange={e => setSearchValue(e.target.value)} onFocus={HandleSearchFocus} onKeyUp={HandleSearchKeyUp} />
                            {state.loading && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-muted-foreground" />}
                        </form>
                        {autocompleteVisible && state.SearchDispay != null && state.SearchDispay[0] && (
                            <div className="absolute top-full left-0 right-0 mt-1 w-full bg-popover border rounded-md shadow-lg z-50 max-h-[200px] overflow-auto">
                                {state.SearchDispay.map((item, index) => {
                                    if (index < 5) {
                                        const n_name = item.cname === "PBM" ? "PCN" : item.cname;
                                        const isLast = index === Math.min(state.SearchDispay.length - 1, 4);
                                        return (
                                            <div className={`flex items-center justify-between px-3 py-2 hover:bg-accent cursor-pointer text-sm ${!isLast ? 'border-b' : ''}`} data-nodename={item.cname} data-nodevalue={item.cvalue} data-nodetype={item.ctype} onClick={HandleSearchItemClick} key={index}>
                                                <span className="font-medium" data-nodename={item.cname} data-nodevalue={item.cvalue} data-nodetype={item.ctype}>{item.cvalue}</span>
                                                <span className="text-muted-foreground">{n_name}</span>
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        )}
                    </div>

                    {/* Filter Dropdown */}
                    <div className={cn("filterNewDesign relative flex-shrink-0", filterDropdownOpen && "active")}>
                        <Button ref={filterButtonRef} variant="outline" size="icon" className="filter-over" onClick={filterDropdown}>
                            <SlidersHorizontal className="h-4 w-4" />
                        </Button>
                        <div ref={filterDropdownRef} className={cn('absolute top-full mt-1 w-48 bg-popover border rounded-md shadow-lg z-50', absoluteMenuAlignClasses(filterMenuAlign), filterDropdownOpen ? 'block' : 'hidden')}>
                            <NavLink to="/filter" className="block px-3 py-2 text-sm text-foreground hover:bg-accent transition-colors rounded-t-md">Create New Filter</NavLink>
                            {state.UserFilterList != null && state.UserFilterList.length > 0 && (
                                <div className="border-t">
                                    {state.UserFilterList.map((e1, i1) => (
                                        <div key={i1} data-filterid={e1.dashboardId} onClick={handleAdFilterClick} className="px-3 py-2 text-sm text-foreground hover:bg-accent transition-colors cursor-pointer">{e1.filterName}</div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Direct/Override Dropdown - Wholesaler */}
                    {(state.userdata.userrole === "Wholesaler" && state.userdata.overrideCount > 0) && (
                        <DropdownMenu onOpenChange={(open) => { if (open) setWholesalerOverrideAlign(computeMenuAlignFromTrigger(wholesalerOverrideTriggerRef.current)); }}>
                            <DropdownMenuTrigger asChild>
                                <Button ref={wholesalerOverrideTriggerRef} variant="secondary" className="h-10 gap-2 flex-shrink-0">
                                    {state.dist_usertype}<ChevronDown className="h-4 w-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align={wholesalerOverrideAlign} className="w-40 p-2">
                                <DropdownMenuItem 
                                    onClick={() => handleBrokerFilter('All')}
                                    className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer border-b rounded-none"
                                >
                                    All
                                </DropdownMenuItem>
                                <DropdownMenuItem 
                                    onClick={() => handleBrokerFilter('Direct')}
                                    className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer border-b rounded-none"
                                >
                                    Direct
                                </DropdownMenuItem>
                                <DropdownMenuItem 
                                    onClick={() => handleBrokerFilter('Override')}
                                    className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer rounded-none"
                                >
                                    Override
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    )}

                    {/* Direct/Override Dropdown - Distributor/Broker */}
                    {((state.userdata.userrole === "Distributor" && state.userdata.overrideCount > 0) || (state.userdata.isBrokerTypeUser && state.userdata.overrideCount > 0)) && (
                        <DropdownMenu onOpenChange={(open) => { if (open) setDistributorBrokerOverrideAlign(computeMenuAlignFromTrigger(distributorBrokerOverrideTriggerRef.current)); }}>
                            <DropdownMenuTrigger asChild>
                                <Button ref={distributorBrokerOverrideTriggerRef} variant="secondary" className="h-10 gap-2">
                                    {state.dist_usertype}<ChevronDown className="h-4 w-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align={distributorBrokerOverrideAlign} className="w-40 p-2">
                                <DropdownMenuItem 
                                    onClick={() => handleBrokerFilter('All')}
                                    className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer border-b rounded-none"
                                >
                                    All
                                </DropdownMenuItem>
                                <DropdownMenuItem 
                                    onClick={() => handleBrokerFilter('Direct')}
                                    className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer border-b rounded-none"
                                >
                                    Direct
                                </DropdownMenuItem>
                                <DropdownMenuItem 
                                    onClick={() => handleBrokerFilter('Override')}
                                    className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer rounded-none"
                                >
                                    Override
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    )}

                    {/* Claim Type Tabs */}
                    {((state.userdata.isBrokerTypeUser === false && state.userdata.isLegacyUser === true) || state.userdata.userrole === "Admin") && (
                        <div className="flex rounded-lg bg-muted p-1 flex-shrink-0">
                            {state.ClaimType.map((p, index) => (
                                <React.Fragment key={index}>
                                    <Button id={p.id} onClick={HandleRXSRadioButton} value={p.value} variant={p.isChecked ? "default" : "ghost"} className={cn("px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap cursor-pointer", !p.isChecked && "text-muted-foreground hover:text-foreground hover:bg-background")}>{p.pname}</Button>
                                    {!p.isChecked && index < state.ClaimType.length - 1 && (
                                        <div className="w-px bg-border self-stretch my-2" />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    )}
                </div>{/* End of flex wrapper */}
            </div>{/* End of dashboard_header_inner */}
            
            {/* Confirm Reload Popup - Transaction type change popup removed */}
            {/* {state.radioButtonSelection && (
                <ConfirmReload 
                    radioButtonSelection={true}
                    titleText={state.ConfirmationMessageTitle}
                    closePopup={() => setState(prev => ({ ...prev, radioButtonSelection: false }))}
                    HandleRadioButtonConfirmation={() => HandleRadioButtonConfirmation(state.radioButtonValue)} 
                    radioButtonValue={state.radioButtonValue}
                />
            )} */}
            {state.searchTextSelection && (
                <ConfirmReload 
                    searchTextSelection={true}
                    SearchTextType={state.searchTextType}
                    SearchTextValue={state.searchTextValue}
                    closePopup={() => setState(prev => ({ ...prev, searchTextSelection: false }))}
                    HandleSearchTextConfirmation={(fieldValue) => {
                        setState(prev => ({
                            ...prev,
                            searchTextSelection: false,
                            ClaimType: prev.ClaimType.map(c => ({ ...c, isChecked: c.value === 'totalpaid' }))
                        }));
                        createAdvanceFilterJson(fieldValue[0], fieldValue[1], 'SearchSelect');
                        localStorage.setItem('Prev_HD_Type', localStorage.getItem('Updated_HD_Type'));
                        localStorage.setItem('Updated_HD_Type', 'totalpaid');
                        localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                        handlechangea();
                    }}
                />
            )}
        </div>
    );
}

export default TopMenu;
